import { render, staticRenderFns } from "./W5V1.vue?vue&type=template&id=30a0a80c&scoped=true&"
import script from "./W5V1.vue?vue&type=script&lang=js&"
export * from "./W5V1.vue?vue&type=script&lang=js&"
import style0 from "./W5V1.vue?vue&type=style&index=0&id=30a0a80c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0a80c",
  null
  
)

export default component.exports